import React from 'react';
import axios from 'axios';
import { AuthService } from './Auth/AuthService';
import { ToastAnt } from './Components/Shared/Toast/ToastAnt';
import * as Utils from 'hermes-tiles-grid-popup';

const apiBaseUrl = Utils.replaceTenantNamePlaceHolder(process.env.REACT_APP_STITCHING_API!);

const instance = axios.create({
  baseURL: apiBaseUrl
});

instance.interceptors.request.use(
  config => {
    return AuthService.getUser().then(user => {
      if (user != null && user.access_token != null) {
        const { access_token } = user;
        config.headers.Authorization = `Bearer ${access_token}`;
      }
      return Promise.resolve(config);
    });
  },
  err => {
    return Promise.reject(err);
  }
);

instance.interceptors.response.use(
  config => config,
  err => {
    if (err && err.response) {
      if (err.response.status === 401) {
        AuthService.login();
      }
      if (err.response.status === 403) {
        if (err.response.request.responseURL.includes('getAssessors')) {
          return Promise.reject(err);
        }
        ToastAnt('You do not have permissions to access requested resource!');
      }
      if (err.response.status >= 500 && err.response.status <= 511) {
        ToastAnt('A server error occurred. Please contact the administrator.');
      }
    }
    return Promise.reject(err);
  }
);

export default instance;
